/**
 * Must match lib/heartbeatCodec.js (UTF-8 Base64 + wire alphabet substitution).
 */

const PLAIN_ALPHABET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/** 65 distinct printable ASCII chars — paired index-wise with PLAIN_ALPHABET */
const WIRE_ALPHABET =
  "!#$%&'()*+,-./:;<=>?@[]^_{|}~ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

if (PLAIN_ALPHABET.length !== WIRE_ALPHABET.length) {
  throw new Error('heartbeat codec alphabet length mismatch');
}

/** @type {Record<string, string>} */
const encodeMap = {};
for (let i = 0; i < PLAIN_ALPHABET.length; i += 1) {
  encodeMap[PLAIN_ALPHABET[i]] = WIRE_ALPHABET[i];
}

const SALT =
  '7!zQ@k#mR2$vL9^wN4&hT*~pX3%jF6|bC8;yG1:dS=+uE5?aK!nH0>qM#wZ2_';

function utf8ToBase64(str) {
  const bytes = new TextEncoder().encode(str);
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function substituteBase64(b64, map) {
  let out = '';
  for (let i = 0; i < b64.length; i += 1) {
    const c = b64[i];
    const m = map[c];
    if (m === undefined) {
      throw new Error('substitute');
    }
    out += m;
  }
  return out;
}

/**
 * @param {object} payload - e.g. { events: [...] }
 * @returns {string} wire token for field `h`
 */
export function encodeHeartbeatBody(payload) {
  const innerJson = JSON.stringify(payload);
  const b64 = utf8ToBase64(innerJson + SALT);
  return substituteBase64(b64, encodeMap);
}
